import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';

export const GET_ALL_BENEFICIARIES_REQUEST = 'GET_ALL_BENEFICIARIES_REQUEST';
export const GET_ALL_BENEFICIARIES_SUCCESS = 'GET_ALL_BENEFICIARIES_SUCCESS';
export const GET_ALL_BENEFICIARIES_FAILURE = 'GET_ALL_BENEFICIARIES_FAILURE';

export const SET_PAYEES = 'SET_PAYEES';

export const getAllBeneficiaries = () => {
	const { uri, method, x_bpi_version } = endpoints.getAllBeneficiaries;
	return {
		[RSAA]: {
			endpoint: uri,
			method,
			types: [GET_ALL_BENEFICIARIES_REQUEST, GET_ALL_BENEFICIARIES_SUCCESS, GET_ALL_BENEFICIARIES_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};
};
